import { Component, inject } from '@angular/core';

import { SharedModule } from '@app/shared/shared.module';
import { Router } from '@angular/router';
import { Route } from '@app/core/enums/route.enum';
import { TranslocoPipe } from '@jsverse/transloco';
import { AuthenticationSandbox } from '@app/core/sandboxes/authentication.sandbox';
import { ButtonComponent } from '@app/shared/ui/button/button.component';

@Component({
  imports: [SharedModule, TranslocoPipe, ButtonComponent],
  templateUrl: './unrecoverable-error.page.html',
  styleUrl: './unrecoverable-error.page.scss'
})
export class UnrecoverableErrorPage {
  router = inject(Router);
  private readonly authenticationSandbox = inject(AuthenticationSandbox);
  message: string | undefined;

  constructor() {
    this.message = this.router.currentNavigation()?.extras?.state?.['message'];
  }

  retry(): void {
    this.router.navigate([Route.Home]);
  }

  logout(): void {
    this.authenticationSandbox.logout();
  }
}
